import { render, staticRenderFns } from "./SourceIndicator.vue?vue&type=template&id=285280f5&scoped=true&"
import script from "./SourceIndicator.vue?vue&type=script&lang=js&"
export * from "./SourceIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SourceIndicator.vue?vue&type=style&index=0&id=285280f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285280f5",
  null
  
)

export default component.exports